module.exports = __webpack_public_path__ + "static/media/cw_dashboard.9cc756d5.png";